import type {
    ManagedServicesVmBody,
    ManagedServicesVmStorageReplica,
    ReplicaType,
} from "@warrenio/api-spec/spec.oats.gen";

function getPrimaryStorage(vm: ManagedServicesVmBody) {
    return vm.resource_allocation.storage?.find((item) => item.primary);
}

export function getReplicasByType(vm: ManagedServicesVmBody, type: ReplicaType) {
    const primaryStorage = getPrimaryStorage(vm);
    return primaryStorage?.replica?.filter((item: ManagedServicesVmStorageReplica) => item.type === type) ?? [];
}
